<template>
      <div class="part9">
      <div class="part9-1">
        <img 
          class="miniImgBigFooter"
          width="136px"
          height="233px"
          src="../assets/img/logoMx.png"
          alt=""
        />
           <img
          class="miniImgFooter"
          width="136px"
          height="233px"
          src="../assets/img/Home/logomini.png"
          alt=""
        />
        <p class="part9Logop">
          Компания Metalix зарекомендовала <br />себя как надежного и
          ответственного <br />производителя, в продукции которого<br />
          вы можете быть уверены.
        </p>
        <div class="footerMini">
          <div class="part9Mail">info@metalix.uz</div>
          <div class="footerMiniSocial">
            <div style="margin-top: 16px">
              <a href="https://t.me/metalixuzb" style=" text-decoration: none;">
              <img src="../assets/img/tg.svg" alt="" /><span
                class="footerSocialt"
                >Telegram</span
              >
              </a>
            </div>
            <div style="margin-top: 16px">
              <a href="https://m.facebook.com/veseliygorod/" style=" text-decoration: none;">
              <img src="../assets/img/fb.svg" alt="" />
              <span class="footerSocialt">facebook</span>
              </a>
            </div>
            <div style="margin-top: 16px">
              <a href="https://instagram.com/metalixuzb?utm_medium=copy_link" style=" text-decoration: none;">
              <img src="../assets/img/In.svg" alt="" />
              <span class="footerSocialt">Instagram</span>
              </a>
            </div>
          </div>
        </div>
        <div class="part9-3">
        <div class="footerLine"></div>
        <h6 class="footerCopyright">© 2021 Metalix. Все права защищены.</h6>
        </div>
      </div>
      <div class="part9-2">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-6 col-sm-12">
               <div class="footerInfoPart1">
             
          <div @click="openClose()">
          <router-link class="link2 ftabout" style="text-decoration: none;" to="about-company"
                >О КОМПАНИИ</router-link></div>
          
          <div @click="openClose()">
          <router-link class="link2 ftabout" style="text-decoration: none;" to="production"
                >Производство</router-link></div>
          
          <div @click="openClose()">
          <router-link class="link2 ftabout footer-all" style="text-decoration: none; margin-top: 48px" to="project"
                >Проекты</router-link></div>
                <div @click="openClose()">
          <router-link class="link2 ftabout" style="text-decoration: none;" to=""
                >Портфолио</router-link></div>
                <div @click="openClose()">
          <router-link class="link2 ftabout" style="text-decoration: none;" to="partner"
                >партнеры</router-link></div>
                <div @click="openClose()">
          <router-link class="link2 ftabout" style="text-decoration: none;" to="news"
                >Новости</router-link></div>
                <div @click="openClose()">
          <router-link class="link2 ftabout" style="text-decoration: none;" to="contact"
                >контакты</router-link></div>
          
        
          </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div class="footerInfoPart2">
            <h3 class="ftManufac2">Направления деятельности</h3>
              <h5 class="ftMtext"><router-link class="link3" to="MetalCons"
                >Металлоконструкции</router-link
              ></h5>
           
             <h5 class="ftMtext"><router-link class="link3" to="Embedded"
                >Закладная деталь</router-link
              ></h5>
              <h5 class="ftMtext"> <router-link class="link3" to="Decorative"
                >Декоративные фонарные столбы</router-link
              ></h5>
             <h5 class="ftMtext"> <router-link class="link3" to="Fences"
                >Заборы и ворота
              </router-link></h5>
            <h5 class="ftMtext"><router-link class="link3" to="Metaldecorative"
                >Металлические декоративные панели</router-link
              ></h5>
            <h5 class="ftMtext mt-5"><router-link class="link3" to="Awnings">Навесы</router-link>
            </h5>
            <h5 class="ftMtext"><router-link class="link3" to="Balcony"
                >Балконные ограждения</router-link
              ></h5>
             <h5 class="ftMtext"><router-link class="link3" to="Parking"
                >Парковочные барьеры</router-link
              ></h5>
             <h5 class="ftMtext"><router-link class="link3" to="Metalstaircase"
                >Перила для лестницы</router-link
              ></h5>
             <h5 class="ftMtext"><router-link class="link3" to="Bus"
                >Автобусная остановка</router-link
              ></h5>
            <h5 class="ftMtext"><router-link class="link3" to="Benches">Скамейки</router-link></h5>
            <h5 class="ftMtext"><router-link class="link3" href="#">Урны для мусора</router-link></h5>
            <h5 class="ftMtext"><router-link class="link3" to="Equipment"
                >Уличные фитнес тренажёры</router-link
              ></h5>
            <h5 class="ftMtext"><router-link class="link3" to="Playgrounds"
                >Детские площадки</router-link
              >
            </h5>
            <h5 class="ftMtext"><router-link class="link3" to="Gazebos">Беседки</router-link>
            </h5>
            <h5 class="ftMtext"> <router-link class="link3" to="Pointers">Указатели</router-link></h5>
          </div>
            </div>

          </div>
        </div>
        <!-- <div class="footerInfoPart">
         

          
        </div> -->
      </div>
    </div>
</template>
<script>
export default {
  name: "footer-sec",
  data() {
    return {
      show: true,
    };
  },
  methods: {
  },
};
</script>
<style scoped>

@font-face {
  font-family: "Inter";
  src: url("~@/assets/font/Inter-Regular.ttf");
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "Inter";
  src: url("~@/assets/font/Inter-SemiBold.ttf");
  font-weight: 600;
  font-style: normal;
}
.router-link-active{
 color: #D19258 !important;


}
.link3 {
  width: 240px;
  height: 16px;
  margin-top: 18px;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  /* identical to box height, or 133% */
  text-decoration: none;
  letter-spacing: 0.1em;

  /* metalix (ligtt,text) */

  color: #36454f;
}
.miniImgFooter{
  display: none;
}

.link2:active{
  /* color: rgb(255, 0, 0) !important; */
}
.part9 {
  display: grid;
  grid-template-columns: 822px 1fr;
  grid-auto-rows: minmax(824, auto);
}
.part9-1 {
  background: #36454f;
}
.part9-2 {
  background: #fbfbfb;
  display: flex;
}
.part9Logop {
  width: 392px;
  height: 128px;
  margin-top: 47px;
  margin-left: 238px;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 32px;
  /* or 200% */
  text-align: left;
  letter-spacing: 2px;
  text-indent: 24px;

  /* _Light */

  color: #fbfbfb;
}
.part9Mail {
  width: 184px;
  height: 24px;
  margin-top: 85px;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  /* identical to box height, or 200% */

  letter-spacing: 0.25em;

  /* line (darck) */

  color: #b4c0cf;

  transform: rotate(-90deg);
}
.footerMini {
  margin-top: 128px;
  display: grid;
  grid-template-columns: 200px 1fr ;
  margin-bottom: 88px;
}
.footerMiniSocial {
  display:block;
  text-align: left;
  margin-left: 35px;
}
.footerLine {
  width: 808px;
  height: 1px;
  margin-bottom: 39px;

  /* _gray_01 */

  background: #d6d6d6;
  opacity: 0.16;
}
.miniImgBigFooter{
  display: flex !important;
  margin-left: 29% !important;
}
.footerCopyright {
  /* width: 392px; */
  height: 24px;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */
  margin-bottom: 48px;
  letter-spacing: 2px;

  /* _Light */

  color: #fbfbfb;

  opacity: 0.32;
}
.footerSocialt {
  width: 336px;
  height: 48px;

  margin-left: 32px;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */
  text-align: left;
  letter-spacing: 0.15em;

  /* _Light */

  color: #fbfbfb;
}
.footerInfoPart {
  display: flex;
  margin-bottom: 80px;
  margin-top: 88px;
  margin-left: 72px;
}
.footerInfoPart1 {
  display: block;
  margin-top: 35px;
}
.footerInfoPart2 {
  display: block;
  margin-top: 35px;
  margin-left: 0px;
  text-align: left;
}
.ftMtextul{
  text-align: left;
   list-style-type: none;
   margin-left: 63px;
}
.ftabout{


font-family: Inter;
font-style: normal;
font-weight: normal;
font-size: 12px;
line-height: 40px;

/* identical to box height, or 333% */
display: flex;
align-items: center;
letter-spacing: 0.05em;
text-transform: uppercase;
margin-left: 73px;
color: #353B50;
}
.ftManufac2{
  width: 272px;
height: 40px;
left: 888px;
top: 12432px;

font-family: Inter;
font-style: normal;
font-weight: normal;
font-size: 12px;
line-height: 40px;

/* identical to box height, or 333% */
display: flex;
align-items: center;
letter-spacing: 0.05em;
text-transform: uppercase;

color: #353B50;
margin-left: 0px;
opacity: 0.25;
}
.ftManufac{
  width: 272px;
height: 40px;
left: 888px;
top: 12432px;

font-family: Inter;
font-style: normal;
font-weight: normal;
font-size: 12px;
line-height: 40px;

/* identical to box height, or 333% */
display: flex;
align-items: center;
letter-spacing: 0.05em;
text-transform: uppercase;

color: #353B50;
margin-left: 73px;
opacity: 0.25;
}
.ftMtext{
  width: 240px;
height: 16px;
left: 904px;
top: 12496px;

font-family: Inter;
font-style: normal;
font-weight: normal;
font-size: 12px;
line-height: 16px;

/* identical to box height, or 133% */
letter-spacing: 0.1em;

color: #353B50;
}
/* Smartphones (portrait and landscape) ----------- */
@media only screen 
and (min-device-width : 320px) 
and (max-device-width : 480px) {
/* Styles */

.link3{
  color: white;
}
.miniImgFooter{
   display: inline;
 }
 .miniImgBigFooter{
   display: none !important;
 }
 .footerInfoPart1{
   margin-left: -3.6rem;
 }
.footerInfoPart2{
  margin-left: 0px !important;
}
.footerInfoPart2 {
  display: block;
  /* margin-left: 5rem; */
  text-align: left;
}
.part9 {
    display: grid ;
    /* grid-gap: 1rem !important; */
    /* grid-template-columns: repeat(auto-fit, minmax(20ch, 1fr)) !important; */
 grid-template-columns:16px 1fr 16px !important;
    background: #36454f;
    grid-auto-rows: minmax(424, auto);
  /* display: grid;
  grid-auto-rows: minmax(824, auto); */
}
.part9-1 {

   grid-column: 2/3 !important;
  grid-row: 1/2 !important;
}
.part9-1 img{
  width: 64px !important;
  height: 64px !important;
  margin-left: -270px !important;
  margin-right: auto !important;
}
.part9-2 {
   grid-column: 2/3 !important;
  grid-row: 2/2 !important;
  background: #36454f;
}
.part9-3{
  display: none;
 /* grid-column: 1/2 !important;
  grid-row: 3/3 !important; */
}
.part9Logop{
 width: 328px !important;
height: 96px !important;
margin-left: 0px !important;

font-family: Inter;
font-style: normal;
font-weight: normal;
font-size: 12px;
line-height: 24px;
/* or 200% */

letter-spacing: 0.1em;
text-indent: 24px;

/* _Light */

color: #FBFBFB;
}
.footerMini{
  display: none !important;
}
.ftMtext{
 width: 60% !important;
height: 16px;

font-family: Inter;
font-style: normal;
font-weight: normal;
font-size: 10px;
line-height: 16px;
/* identical to box height, or 160% */

letter-spacing: 0.1em;

/* _Light */

color: #FBFBFB !important;
}

.ftabout{
  width: 152px;
height: 24px;
left: 16px;
margin-bottom: 1rem;
font-family: Inter;
font-style: normal;
font-weight: normal;
font-size: 12px;
line-height: 24px;
/* identical to box height, or 200% */

display: flex;
align-items: center;
letter-spacing: 0.05em;
text-transform: uppercase;

/* _Light */

color: #FBFBFB !important;
}
.ftManufac2{
  width: 222px;
height: 24px;
margin-left: 0px ;
margin-top: 24px;
margin-bottom: 26px;

font-family: Inter;
font-style: normal;
font-weight: normal;
font-size: 12px;
line-height: 24px;
/* identical to box height, or 200% */
margin-left: 1rem;
display: flex;
align-items: center;
letter-spacing: 0.05em;
text-transform: uppercase;

/* _Light */

color: #FBFBFB;

opacity: 0.25;
}
.ftManufac{
  width: 152px;
height: 24px;
margin-left: 0px ;
margin-top: 24px;
margin-bottom: 26px;

font-family: Inter;
font-style: normal;
font-weight: normal;
font-size: 12px;
line-height: 24px;
/* identical to box height, or 200% */

display: flex;
align-items: center;
letter-spacing: 0.05em;
text-transform: uppercase;

/* _Light */

color: #FBFBFB;

opacity: 0.25;
}
.ftMtextul{
  text-align: left;
   list-style-type: none;
}
.ftMtext{
  width: 200px !important;
height: 32px !important;
margin-left: 2rem;
font-family: Inter;
font-style: normal;
font-weight: normal;
font-size: 10px;
line-height: 16px;
/* or 160% */

letter-spacing: 0.1em;

/* _Light */

color: #FBFBFB;

}
.footer-all{
  margin-top: 0 !important;
}
}

/* Smartphones (landscape) ----------- */
@media only screen 
and (min-width : 321px) {
/* Styles */
}

/* Smartphones (portrait) ----------- */
@media only screen 
and (max-width : 320px) {
/* Styles */
}

/* iPads (portrait and landscape) ----------- */
@media only screen 
and (min-device-width : 768px) 
and (max-device-width : 1024px) {
/* Styles */
.part9 {
  display: grid;
  grid-template-columns: 1fr;
  grid-auto-rows: minmax(824, auto);
}
.part9-1 {
  background: #36454f;
}
.part9-2 {
  /* background: #fbfbfb; */
  display: none;
}
.footerLine{
  width: 700px;
}

}

/* iPads (landscape) ----------- */
@media only screen 
and (min-device-width : 768px) 
and (max-device-width : 1024px) 
and (orientation : landscape) {
/* Styles */
}

/* iPads (portrait) ----------- */
@media only screen 
and (min-device-width : 768px) 
and (max-device-width : 1024px) 
and (orientation : portrait) {
/* Styles */
}

/* Desktops and laptops ----------- */
@media only screen 
and (min-device-width : 1025px) 
and (max-width : 1224px) {
/* Styles */
.part9 {
  display: grid;
  grid-template-columns: 408px 1fr;
  grid-auto-rows: minmax(824, auto);
}
.part9Logop {
  margin-left: 38px;
 
  font-size: 11px;
 
}
.footerMini {
  display: flex;
  justify-content: left;

}
}
/* Desktops and laptops  1280----------- */
@media (min-width: 1025px)
and (max-width : 1280px) {
/* Styles */

  .ftMtext{
    margin-top: 25px;
  }
.part9 {
  display: grid;
  grid-template-columns: 488px 1fr !important;
  grid-auto-rows: minmax(824, auto);
}
.part9Logop {
  margin-left: 38px;
 
  font-size: 11px;
 
}
.footerMini {
  display: flex;
  justify-content: left;

}
}
@media only screen   
and (min-width: 1280px)   
and (max-width: 1366px){
  .part9 {
  display: grid;
  grid-template-columns: 506px 1fr;
  grid-auto-rows: minmax(824, auto);
}
.part9Logop{
  margin-left: 38px;
}

.footerMini {
  display: flex;
  justify-content: left;

}
}
/**1281px** */
@media (min-width: 1367px)
and (max-width : 1440px) {
  
.part9 {
  display: grid;
  grid-template-columns: 547px 1fr !important ;
  grid-auto-rows: minmax(824, auto);
}
.part9Logop{
  margin-left: 38px;
}

.footerMini {
  display: flex;
  justify-content: left;

}
.part9Mail{
    width: 90px !important;
  }
}
/* Large screens ----------- */
@media only screen 
and (min-width : 1824px) {
/* Styles */
.ftMtext{
  margin-top: 30px;
}
.part13-0T{
  margin-top: 155px !important;
}
}

/* iPhone 4 ----------- */
@media
only screen and (-webkit-min-device-pixel-ratio : 1.5),
only screen and (min-device-pixel-ratio : 1.5) {
/* Styles */
}
/* ----------- Retina Screens ----------- */
@media screen 
  and (min-device-width: 1200px) 
  and (max-device-width: 1600px) {
    .part9 {
  display: grid;
  grid-template-columns:18%,1fr;
  grid-auto-rows: minmax(824, auto);
  }
  .ftMtext{
  margin-top: 30px;
}
  }
  @media screen and (min-device-width: 1441px) and (max-device-width: 1600px) and (-webkit-min-device-pixel-ratio: 1) {
    .part9 {
  display: grid;
  grid-template-columns:708px 1fr !important;
  grid-auto-rows: minmax(824, auto);
  }
  }
</style>